import { UserAuthProvider } from '@shared/Authentication/shared/infrastructure/store/auth.hooks';

const WithUser = ({ children }) => {
  return <UserAuthProvider>{children}</UserAuthProvider>;
};

export { WithUser };
